import { UntitledIcon } from '@faceup/icons'
import { ulAlertCircle } from '@faceup/icons/ulAlertCircle'
import { ulXClose } from '@faceup/icons/ulXClose'
import { Typography } from '@faceup/ui-base'
import { useState } from 'react'
import { Card } from '../Card'
import { UnstyledButton } from '../UnstyledButton'

type EnviromentMessageProps = {
  environment: string
}

export const EnvironmentMessage = ({ environment }: EnviromentMessageProps) => {
  const [isVisible, setIsVisible] = useState<boolean>(true)
  if (!isVisible) {
    return null
  }
  return (
    <div className='fixed bottom-4 left-20 z-1000'>
      <Card className='relative flex select-none items-center gap-2 px-4 py-2 capitalize'>
        <UntitledIcon icon={ulAlertCircle} className='text-orange5' />
        <Typography.Text strong>{environment} environment</Typography.Text>
        <div
          className={
            'absolute top-0 right-0 bottom-0 left-0 flex items-center justify-start opacity-0 transition-all hover:opacity-100'
          }
        >
          <UnstyledButton className='h-full bg-white ps-4 pe-2' onClick={() => setIsVisible(false)}>
            <UntitledIcon icon={ulXClose} />
          </UnstyledButton>
        </div>
      </Card>
    </div>
  )
}
